import { AppState } from 'Store'

const getIsMobile = (state: AppState) => state.modules.device.isMobile
const getIsTablet = (state: AppState) => state.modules.device.isTablet

export const deviceDetect = {
	getIsMobile,
	getIsTablet,
}
